import React from 'react';
import { useTranslation } from 'react-i18next';
import { ViewStyle } from 'react-native';

import PlayIcon from '@/assets/icons/play';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { designSystem } from '@/styles/styles';
import { CardSegment } from '@/types/api.generated';
import { MAX_WEB_WIDTH } from '@/utils/constants-platform-specific';
import { renderDate, renderTime } from '@/utils/renderDate';
import { parseISO } from 'date-fns';

export type CardSegmentTitleType = {
    __typename: 'CardSegmentTitle';
    cardSegment: CardSegment;
    startDate: string;
    tournamentStartDate?: string;
};

type CardSegmentTitleProps = {
    cardSegmentDetails: CardSegmentTitleType;
    style?: ViewStyle;
};

export const CardSegmentTitle = ({ cardSegmentDetails, style }: CardSegmentTitleProps) => {
    const { t } = useTranslation('pickem_leagues');
    const segmentStartDate = parseISO(cardSegmentDetails.startDate);
    const tournamentStartDate = parseISO(cardSegmentDetails.tournamentStartDate || '');

    const isCardSegmentLive = segmentStartDate <= new Date();

    const hasTournamentStarted = cardSegmentDetails ? tournamentStartDate <= new Date() : false;

    const dateTimeLabel = renderDate(segmentStartDate);

    const timeOnly = renderTime(segmentStartDate);

    return (
        <Row
            paddingHorizontal={'s16'}
            paddingBottom={'s4'}
            paddingTop={'s16'}
            alignItems={'center'}
            style={style}
            maxWidth={MAX_WEB_WIDTH}
            width={'100%'}
            alignSelf={'center'}
        >
            <Text variant="titleMedium">{t(`ufc_segments.${cardSegmentDetails.cardSegment}`)}</Text>
            {isCardSegmentLive ? (
                <Box marginLeft={'s4'}>
                    <PlayIcon color={designSystem.colors.red2} />
                </Box>
            ) : (
                <Row alignItems="center" gap="s2" paddingHorizontal={'s2'}>
                    <Text>•</Text>
                    <Text variant="bodyMedium" color="gray3">
                        {hasTournamentStarted ? t('ufc_segments.startsAt', { time: timeOnly }) : dateTimeLabel}
                    </Text>
                </Row>
            )}
        </Row>
    );
};
